<template>
  <div>
    <v-filter>
      <el-form slot="filter" :model="filter" inline @submit.native.prevent="loadList()">
        <el-form-item label="姓名">
          <el-input v-model="filter.name"></el-input>
        </el-form-item>
      </el-form>
      <div>
        <el-button type="primary" @click="edit()">新增规格</el-button>
      </div>
    </v-filter>

    <el-table :data="list" stripe row-key="id">
      <el-table-column prop="name" label="名称"></el-table-column>
      <el-table-column prop="is_enable" label="是否开启">
        <span slot-scope="scope">{{scope.row.is_enable ? '是' : '否'}}</span>
        <!-- <el-switch v-model="scope.row.is_enable" slot-scope="scope" @change="onChangeIsEnable(scope.row)"> </el-switch> -->
      </el-table-column>
      <el-table-column width="100px">
        <div slot-scope="scope">
          <el-button type="text" @click="edit(scope.row)">编辑</el-button>
          <el-button type="text" @click="del(scope.row.id)">删除</el-button>
        </div>
      </el-table-column>
    </el-table>

    <v-page v-model="filter" @change="loadList"></v-page>

    <el-drawer :title="`${!form.id ? '新增' : '编辑'}规格`" :visible.sync="visible" direction="rtl">
      <el-form :model="form" ref="form" :rules="rules" label-width="120px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="开启" prop="is_enable">
          <el-switch v-model="form.is_enable"></el-switch>
        </el-form-item>
        <el-form-item label="排序" prop="order">
          <el-input v-model="form.order"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="commit">提交</el-button>
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
export default {
  name: 'Specs',
  data() {
    return {
      visible: false,
      filter: {
        page: 1,
        page_size: 10
      },
      form: {},
      list: [],
      sub_list: [],
      expands: [],
      total: 0,
      rules: {
        name: [{ required: true, message: '必填！', trigger: 'blur' }],
        is_enable: [{ required: true, message: '必填！', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.loadList(1)
  },
  methods: {
    async edit(row = {}) {
      try {
        this.form = {}
        if (!row.id) return
        await this.loadInfo(row.id)
      } finally {
        this.visible = true
      }
    },

    async del(id) {
      await this.$confirm('确认删除吗？')
      await this.$api.shop.specs.getSpecs(id)
      this.$message.success('删除成功！')
    },

    async loadList(page = 1) {
      this.filter.page = page
      const { data } = await this.$api.shop.specs.getSpecs(this.filter)
      this.list = data.items
      this.filter.total = data.totalItems
    },

    async loadInfo(id) {
      const { data } = await this.$api.shop.specs.getSpecsId(id)
      this.form = data
    },

    async commit() {
      await this.$validate(this.$refs.form)
      const { id } = this.form
      if (!id) {
        await this.$api.shop.specs.postSpecs(this.form)
      } else {
        await this.$api.shop.specs.putSpecs(id, this.form)
      }

      await this.loadList(1)

      this.$message.success('保存成功！')
      this.visible = false
    },
  }
}
</script>
